.title {
    color: #3caeb0;
    text-align: center;
    padding: 0 40px;
}

@media (max-width: 479px) {
    .title {
        padding-inline: 0;
        overflow-wrap: normal;
        word-break: normal;
    }
}


.greetingText {
    text-align: center;
}


.content {
    width: 100dvw;
    background-color: white;
}

@media (min-width: 768px) {
    .content {
        width: 500px;
    }
}

.baseContainer {
    background-image: image-set(
        url("/optimized/free-consult-live-1170.webp") type("image/webp"),
        url("/free-consult-live.jpg") type("image/jpeg")
    );
    background-repeat: no-repeat;
    background-size: cover;
    background-position: left;
    background-attachment: fixed;
}
